import {
  SLTXFormatRootFileGroup,
} from '../../fileFormats/sltx/sltx';

import {
  ModelTreeNode,
  ModelTreeNodeDataFolder,
  ModelTreeNodeDataOption,
  ParsedTreeNodeType,
} from '../data/modelOptionsTree';

//-------------------------------------------------------------------------
// class ModelParser
// This class helps parse the SLTX file into a tree of model options.
// This tree will be further manipulated according to the rules, and
// so on.
//-------------------------------------------------------------------------

export class ModelParser {

  public static buildModelTreeFromGroups(
    originGroups : SLTXFormatRootFileGroup[],
  ) : ModelTreeNode {

    // Create the root node
    const root = new ModelTreeNode();
    root.name = '<root>';
    root.type = ParsedTreeNodeType.Root;

    // Iterate over each group
    originGroups.forEach((groupData) => {

      // Create a new group
      const groupNode = new ModelTreeNode();
      groupNode.type = ParsedTreeNodeType.Group;
      groupNode.id = groupData.id;
      groupNode.name = groupData.name;
      groupNode.tagTranslation = groupData.tagTranslation;

      // Check if we only a subgroup. If that's the case, there's no need to create sublevels

      if (groupData.optionsFolders.length === 1) {
        const subgroupData = groupData.optionsFolders[0];

        // Go through all the options in the subgroup
        subgroupData.options.forEach((optionData) => {

          // Collect the data
          const optionNodeData = new ModelTreeNodeDataOption();
          optionNodeData.objectRef = optionData.objectRef;
          optionNodeData.thumbnailRef = optionData.thumbnailRef;
          optionNodeData.groupID = groupData.id;

          // Create the option node
          const optionNode = new ModelTreeNode();
          optionNode.tagTranslation = optionData.tagTranslation;
          optionNode.tagTranslationSection = optionData.tagTranslationSection;
          optionNode.type = ParsedTreeNodeType.Option;
          optionNode.id = optionData.id;
          optionNode.name = optionData.name;
          optionNode.data = optionNodeData;

          // Add if to the target folder
          groupNode.children.push(optionNode);

        });

      } else {
        // Go through all the subgroups
        groupData.optionsFolders.forEach((subgroupData) => {
          // Collect the data
          const folderNodeData = new ModelTreeNodeDataFolder();
          folderNodeData.thumbnailRef = subgroupData.thumbnailRef;

          // Create a node for the subgroup
          const subGroupNode = new ModelTreeNode();
          subGroupNode.tagTranslation = subgroupData.tagTranslation;
          subGroupNode.name = subgroupData.name;
          subGroupNode.type = ParsedTreeNodeType.Folder;
          groupNode.children.push(subGroupNode);
          subGroupNode.data = folderNodeData;

          // Go through all the options in the subgroup
          subgroupData.options.forEach((optionData) => {

            // Collect the data
            const optionNodeData = new ModelTreeNodeDataOption();
            optionNodeData.objectRef = optionData.objectRef;
            optionNodeData.thumbnailRef = optionData.thumbnailRef;
            optionNodeData.groupID = groupData.id;

            // Create the option node
            const optionNode = new ModelTreeNode();
            optionNode.tagTranslation = optionData.tagTranslation;
            optionNode.tagTranslationSection = optionData.tagTranslationSection;
            optionNode.type = ParsedTreeNodeType.Option;
            optionNode.id = optionData.id;
            optionNode.name = optionData.name;
            optionNode.data = optionNodeData;

            // Add if to the target folder
            subGroupNode.children.push(optionNode);
          });
        });

      }

      root.children.push(groupNode);
    });

    // Return the array of groups
    return root;
  }
}
